import(/* webpackMode: "eager" */ "/home/ubuntu/user-b2c/src/components/category/Category.jsx")